var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5077_43137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5077_43137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H74C77.3137 48 80 45.3137 80 42V6C80 2.68629 77.3137 0 74 0Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.623 31.5942L67.5001 24.4084L63.7689 16.9746L59.623 31.5942Z",
    fill: "#097939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9697 31.5942L64.8468 24.4084L61.1156 16.9746L56.9697 31.5942Z",
    fill: "#ED752E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3259 17.0593L16.0094 28.8705L27.7832 28.953L31.0172 17.0593H34.0021L30.1246 30.8863C29.9761 31.4143 29.4107 31.8433 28.8623 31.8433H13.7709C12.8557 31.8433 12.3134 31.1283 12.5609 30.2483L16.2591 17.0593H19.3259ZM55.726 16.9768H58.7108L54.5649 31.8433H51.4959L55.726 16.9768ZM34.3343 23.1709L49.2591 23.0884L50.2546 19.9495H35.0801L35.992 17.0587L52.162 16.9102C53.1685 16.9009 53.768 17.6802 53.5029 18.6521L51.9794 24.2203C51.7137 25.1916 50.6814 25.9786 49.6749 25.9786H36.3242L34.7501 32.0908H31.8461L34.3343 23.1709Z",
    fill: "#747474"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5077_43137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5077_43137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpi);
export default __webpack_public_path__ + "static/media/ic-upi.c1f54973940cec39eb0960a5d9a32085.svg";
export { ForwardRef as ReactComponent };